import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { UserRowComponent } from "./user-row/user-row.component";
import { User } from "../../@core/data/users"
import { UserService } from "../../@core/api/users.service"
import { NbWindowService, NbWindowState } from '@nebular/theme';
import {UserCreateComponent} from "../user-create/user-create.component"
import { LenguageService } from '../../@core/utils/lenguage.service'

@Component({
  selector: 'ngx-users-table',
  templateUrl: './users-table.component.html',
  styleUrls: ['./users-table.component.scss']
})
export class UsersTableComponent implements OnInit {
  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  users: User[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 100,
    pageNumber: 0
  }
  order = {
    field: "timestamp",
    direction: "desc"
  }
  range: any;
  selectedRowId: string;
  addFilter: boolean = false;
  dateRange: {
    dateStart: number,
    dateEnd: number,
  }

  constructor(
    private windowService: NbWindowService,
    private userService: UserService,
    public language: LenguageService
  ) {

  }

  async ngOnInit() {

    this.getUsers();

  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getUsers();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getUsers();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads; */
  }

  async getUsers() {
    this.loading = true;
    this.users = <User[]>await this.userService.getUsers(this.pagination, this.filters, this.order);
    this.loading = false;

    if (this.users.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }

  }

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = new Date(this.range.start).getTime() * 1000 / 1000;
    this.filters.dateRange = { dateStart, dateEnd };

  }

  async createUser(){
    this.windowService.open(UserCreateComponent, {  title: "Crea nuovo utente"})
      .onClose.subscribe(() => this.getUsers())
  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getUsers();
  }

}
